/** MUI */
import { alpha, Card, CardHeader, CardContent, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.25),
    },
}));

const InfoWidgetSkeleton = () => {
    const classes = useStyles();
    return (
        <Card sx={{ "&": (theme) => ({ ...theme.shape.boxedWrapper, borderRadius: "20px", p: 1, width: "100%" }) }}>
            <CardHeader
                action={
                    <Skeleton animation="wave" variant="circular" width={32} height={32} className={classes.skeleton} />
                }
                title={<Skeleton animation="wave" height={24} width="90%" className={classes.skeleton} />}
                sx={{ pb: 0 }}
            />
            <CardContent>
                <Skeleton animation="wave" height={36} width="40%" sx={{ mb: 0 }} className={classes.skeleton} />
                <Skeleton animation="wave" height={24} width="50%" sx={{ mb: 0 }} className={classes.skeleton} />
            </CardContent>
        </Card>
    );
};

export default InfoWidgetSkeleton;
